import { useState, FormEvent } from 'react';

export default function NewsletterSection() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [message, setMessage] = useState('');

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);

    const honeypot = formData.get('phone_alt') as string;
    if (honeypot && honeypot.trim() !== '') {
      setStatus('success');
      setMessage('感谢订阅！');
      setEmail('');
      return;
    }

    setStatus('loading');

    try {
      const res = await fetch('https://readdy.ai/api/form/d9q9p77nahb7382ov8b0', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams({ email: formData.get('email') as string }).toString(),
      });
      const responseText = await res.text();
      let parsed;
      try { parsed = JSON.parse(responseText); } catch { parsed = null; }

      if (res.ok && parsed?.code === 'OK') {
        setStatus('success');
        setMessage('感谢订阅！我们会将最新推荐发送到您的邮箱。');
        setEmail('');
      } else {
        const serverMsg = parsed?.meta?.message || parsed?.message || '订阅失败，请稍后再试';
        setStatus('error');
        setMessage(serverMsg.includes('spam') ? '订阅失败，请稍后再试' : serverMsg);
      }
    } catch {
      setStatus('error');
      setMessage('网络错误，请稍后再试');
    }
  };

  return (
    <section className="py-14 md:py-20 bg-background-950">
      <div className="max-w-2xl mx-auto px-4 md:px-6 text-center">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-50">
          订阅新闻简报
        </h2>
        <p className="mt-3 text-sm text-foreground-400 leading-relaxed">
          每周五获取最新漫画推荐、独家内容和阅读指南，第一时间了解漫境动态。
        </p>
        <form
          onSubmit={handleSubmit}
          className="mt-8 flex flex-col sm:flex-row gap-3 max-w-md mx-auto"
          data-readdy-form=""
        >
          <input
            type="text"
            name="phone_alt"
            tabIndex={-1}
            autoComplete="off"
            readOnly
            aria-hidden="true"
            className="bot-field"
          />
          <input
            type="email"
            name="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="请输入您的邮箱地址"
            required
            className="flex-1 px-4 py-3 text-sm bg-background-800 border border-background-700 rounded-md text-foreground-100 placeholder:text-foreground-500 focus:outline-none focus:border-primary-500 transition-colors"
          />
          <button
            type="submit"
            disabled={status === 'loading'}
            className="px-6 py-3 bg-primary-500 text-background-50 text-sm font-semibold rounded-md hover:bg-primary-600 disabled:opacity-60 transition-all whitespace-nowrap cursor-pointer"
          >
            {status === 'loading' ? '提交中...' : '订阅'}
          </button>
        </form>
        {message && (
          <p className={`mt-4 text-sm ${status === 'success' ? 'text-accent-400' : 'text-primary-400'}`}>
            {message}
          </p>
        )}
        <p className="mt-4 text-xs text-foreground-500">我们尊重您的隐私，不会泄露您的邮箱地址</p>
      </div>
    </section>
  );
}